/* unplugin-vue-components disabled */import { render } from "./OverlayComponent.vue?vue&type=template&id=bf185eee&ts=true"
import script from "./OverlayComponent.vue?vue&type=script&lang=ts"
export * from "./OverlayComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__